import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import classNames from "classnames";
import Cookies from "js-cookie";
import Button, { ButtonColor, ButtonKind } from "../../elements/Button";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import LinkItem from "./components/LinkItem";
import rehydrator from "./DismissibleBanner.rehydrator";

var DismissibleBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(DismissibleBanner, _React$Component);

  var _super = _createSuper(DismissibleBanner);

  function DismissibleBanner() {
    var _this;

    _classCallCheck(this, DismissibleBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // We do not display the banner for the first render
      // because it would give a jerking motion (appear and then
      // quickly disappear) if it is closed
      closed: true
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(DismissibleBanner.displayName));

    _defineProperty(_assertThisInitialized(_this), "handleCloseBanner", function () {
      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "handleAcceptCookies", function () {
      _this.close();

      _this.dismiss();
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        closed: true
      });
    });

    return _this;
  }

  _createClass(DismissibleBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        closed: this.hasBeenDismissed()
      });
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      if (!DismissibleBanner.cookiesEnabled()) {
        // If cookies are disabled, then this banner should not
        // even be displayed
        return;
      }

      var cookieOptions = {
        expires: 365,
        domain: ""
      };

      var _iterator = _createForOfIteratorHelper(this.props.validParentDomains),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var domain = _step.value;

          if (window.location.hostname.endsWith(domain)) {
            cookieOptions.domain = ".".concat(domain);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Cookies.set(this.props.alreadySeenCookieName, this.props.alreadySeenCookieExpectedValue, cookieOptions);
    }
  }, {
    key: "hasBeenDismissed",
    value: function hasBeenDismissed() {
      if (!DismissibleBanner.cookiesEnabled()) {
        // If cookies are disabled, then this banner should not
        // even be displayed
        return true;
      }

      return Cookies.get(this.props.alreadySeenCookieName) === this.props.alreadySeenCookieExpectedValue;
    }
  }, {
    key: "render",
    value: function render() {
      var rehydrationProps = {
        "data-dismiss-button-text": this.props.dismissButtonText,
        "data-close-button-text": this.props.closeButtonText,
        "data-fixed": this.props.fixed || false,
        "data-rehydratable": getRehydratableName(DismissibleBanner.displayName),
        "data-already-seen-cookie-name": this.props.alreadySeenCookieName,
        "data-already-seen-cookie-expected-value": this.props.alreadySeenCookieExpectedValue,
        "data-valid-parent-domains": JSON.stringify(this.props.validParentDomains)
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        role: "alertdialog",
        className: this.getClassName({
          modifiers: classNames({
            fixed: this.props.fixed
          }),
          states: classNames({
            closed: this.state.closed
          })
        })
      }, rehydrationProps), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "closeButtonWrapper"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "closeButtonLabel"
        })
      }, this.props.closeButtonText), /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "closeButton"
        }),
        onClick: this.handleCloseBanner
      }, /*#__PURE__*/React.createElement(CrossIcon, {
        label: "Close"
      }))), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "wrapper"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "inner"
        })
      }, /*#__PURE__*/React.createElement("p", {
        className: this.getClassName({
          descendantName: "heading"
        })
      }, this.props.heading), /*#__PURE__*/React.createElement("p", {
        className: this.getClassName({
          descendantName: "text"
        })
      }, this.props.text), this.props.children ? /*#__PURE__*/React.createElement("ul", {
        className: this.getClassName({
          descendantName: "links"
        })
      }, this.props.children) : null), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "button"
        })
      }, /*#__PURE__*/React.createElement(Button, {
        color: ButtonColor.SECONDARY,
        kind: ButtonKind.BUTTON,
        onClick: this.handleAcceptCookies
      }, this.props.dismissButtonText))));
    }
  }], [{
    key: "cookiesEnabled",
    value: function cookiesEnabled() {
      // cookieEnabled needs to be exactly false, not undefined or null
      if (typeof navigator !== "undefined" && navigator.cookieEnabled === false) {
        return false;
      }

      return true;
    }
  }]);

  return DismissibleBanner;
}(React.Component);

_defineProperty(DismissibleBanner, "displayName", "DismissibleBanner");

_defineProperty(DismissibleBanner, "LinkItem", void 0);

_defineProperty(DismissibleBanner, "rehydrator", rehydrator);

_defineProperty(DismissibleBanner, "defaultProps", {
  alreadySeenCookieName: "tr_ewp_dismissiblebanner",
  alreadySeenCookieExpectedValue: "may2018",
  closeButtonText: "Close",
  dismissButtonText: "Okay to continue",
  // eslint-disable-next-line
  // TODO: these should be env variables
  validParentDomains: ["refinitiv.com", "reuters.com", "thomsonreuters.com"]
});

DismissibleBanner.LinkItem = LinkItem;
export default DismissibleBanner;